

export enum IconType {
    ITEM_ICONS      = 0,
    EMOJI_ICONS     = 1,
    URL             = 2
}

export const IconTabsOptions: Option[] = [
    {
        value: IconType.ITEM_ICONS,
        label: "Icons"
    },
    {
        value: IconType.EMOJI_ICONS,
        label: "Emoji"
    },
    {
        value: IconType.URL,
        label: "Url"
    }
]
